import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useRptCa, useRptMain } from "../../../St/Reviews/UseStyle";
import moment from "moment";

function HeaderCashiar(props) {
  const { found, sta, locInv, onUnmountComplete } = props;

  const clasm = useRptMain();
  const clas = useRptCa();
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  const styleE = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
    fontSize: "0.8rem",
    color: "black",
    fontWeight: "bold",
  };

  const style2 = {
    textAlign: "center",
    paddingTop: "0.01rem",
    paddingBottom: "0.01rem",
    fontSize: "0.95rem",
    color: "black",
    fontWeight: "bold",
  };


  const styleLeft = {
    textAlign: "left",
    paddingTop: "0.01rem",
    paddingBottom: "0.01rem",
    fontSize: "0.95rem",
    color: "black",
    fontWeight: "bold",
  };

  useEffect(() => {
    setTimeout(async () => {
      onUnmountComplete();
    }, 0);
  }, []);
  return (
    <Grid item container className={clas.Hedroot}>
      <Grid item xs={12} className={clasm.mincntr}>
        <Typography>
          <ButtonBase>
            {" "}
            <img
              src={`data:image/jpeg;base64,${found.Logo}`}
              className={clas.Hedlogo}
              alt={found.nameA}
            />{" "}
          </ButtonBase>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography className={clasm.mincntr} style={style2}>{found.nameA}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={clasm.mincntr} style={style2}>{found.nameE}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography className={clasm.mincntr} style={style2}>{found.Mobile}</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography className={clasm.mincntr} style={style2}>{found.Address}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={styleLeft}>{found.tax_no}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={style2}>{"الرقم الضريبي"} </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={styleLeft}>{found.bsn_no}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={style2}>{"السجل التجاري "} </Typography>
      </Grid>



      {locInv?.ProcTypeInvProc != "03" && parseFloat(sta?.tot?.amountOfVat) > 0 && (
        <Grid item xs={12}>
          <Typography className={clasm.mincntr} style={style2} >
            {sta?.tot?.tax_no_cust === ""
              ? "فاتورة ضريبية مبسطة"
              : "فاتورة ضريبية"}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography className={clasm.mincntr} style={styleE}>
          {(locInv.ProcTypeInvProc === "12" ? " اشعار دائن " + "(مرتجع مبيعات) " : locInv.invN) +
            " " +
            sta.tot.inv_type_name +
            " " +
            sta.tot.pay_type_name}
        </Typography>
      </Grid>

      <Grid item container >
        <Grid item container style={{ fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
          <Grid item xs={8} style={styleE}>
            {sta.tot.id}
          </Grid>
          <Grid item xs={4} style={styleE}>
            {'رقم الفاتورة'}
          </Grid>
          <Grid item xs={8} style={styleE}>
            {moment(sta.tot.date).format("YYYY/MM/DD")}  {moment(sta.tot.date).format("hh:mm A")}
          </Grid>
          <Grid item xs={4} style={styleE}>
            {'تاريخ الفاتورة'}
          </Grid>
          <Grid item xs={8} style={styleE}>
            {sta.tot.cust_name}
          </Grid>
          <Grid item xs={4} style={styleE}>
            {'اسم العميل'}
          </Grid>
          <Grid item xs={8} style={styleE}>
            {sta?.tot?.cust_address + " - " + sta?.tot?.cust_mobile}
          </Grid>
          <Grid item xs={4} style={styleE}>
            {'بيانات العميل'}                </Grid>
          <Grid item xs={8} style={styleE}>
            {sta.tot.tax_no_cust}
          </Grid>
          <Grid item xs={4} style={styleE}>
            {'الرقم الضريبي'}
          </Grid>

          {(premiApp?.cashirTemplate === 5 || locInv?.printType === 8) && (
            <>
             {locInv?.printType === 8 &&
                <>
                  <Grid item xs={8} style={styleE}>
                    {sta.tot.CarColor}
                  </Grid>
                  <Grid item xs={4} style={styleE}>
                    {"رقم الجوال"}
                  </Grid>
                </>
              }
              <Grid item xs={8} style={styleE}>
                {locInv?.printType === 8 ?sta.tot.CarModel:sta.tot.CarType}
              </Grid>
              <Grid item xs={4} style={styleE}>
                {locInv?.printType === 8 ? "الطول" : 'طراز السيارة'}
              </Grid>
              <Grid item xs={8} style={styleE}>
                {locInv?.printType === 8 ?sta.tot.CarPlatNum:sta.tot.CarModel}
              </Grid>
              <Grid item xs={4} style={styleE}>
                {locInv?.printType === 8 ? "الصدر" : 'الموديل'}
              </Grid>
              <Grid item xs={8} style={styleE}>
                {locInv?.printType === 8 ?sta.tot.CarYear:sta.tot.CarColor}
              </Grid>
              <Grid item xs={4} style={styleE}>
                {locInv?.printType === 8 ? "طول الكم" : 'عدد الكيلومتر'}
              </Grid>
              <Grid item xs={8} style={styleE}>
                {locInv?.printType === 8 ?sta.tot.CarType:sta.tot.CarYear}
              </Grid>
              <Grid item xs={4} style={styleE}>
                {locInv?.printType === 8 ? "الابط" : 'سنة الصنع'}
              </Grid>
              <Grid item xs={8} style={styleE}>
                {locInv?.printType === 8 ?sta.tot.CarStructure:sta.tot.CarPlatNum}
              </Grid>
              <Grid item xs={4} style={styleE}>
                {locInv?.printType === 8 ? "فتحة الكم" : 'رقم اللوحة'}
              </Grid>
              {locInv?.printType === 8 &&
                <>
                  <Grid item xs={8} style={styleE}>
                    {sta.tot.CarVactor}
                  </Grid>
                  <Grid item xs={4} style={styleE}>
                    {"الورك"}
                  </Grid>
                </>
              }
            </>
          )}

        </Grid>
      </Grid>


    </Grid>
  );
}
export default HeaderCashiar;
